import { tryUntilResolve, rejectClientErrors } from '@twnel/web-components';
import { loadConversations, updateUnreadCounts } from 'src/data/actions';

export default function refreshData() {
  return async (dispatch) => {
    await dispatch(tryUntilResolve(loadConversations(), rejectClientErrors));
    dispatch(updateUnreadCounts());
  };
}
